<div class="questionWrapper">
  <span class='questionHeader'>
    <span class='questionNumberText' [innerHTML]="questionData.numberText"></span>
    <span [ngClass]="{ 'question-text' : questionData.numberText == null || questionData.numberText == '' }" [innerHTML]="questionData.text"></span>
  </span>
</div>
